import React from 'react';
import {
	LegacyFormDateField,
	type LegacyFormDateFieldProps,
} from '@netx/core-components/Form/DateField';
import type {ICustomFormItem} from '../../types';
import {
	getCustomFormItemTranslatedLabel,
	getCustomFormBaseFieldName,
} from '../../utils';

export interface LegacyFormCustomFormItemDateProps
	extends Omit<
		LegacyFormDateFieldProps,
		'multiline' | 'label' | 'name' | 'required'
	> {
	item: ICustomFormItem<'date'>;
}

export const LegacyFormCustomFormItemDatePrimitive = ({
	item,
	...props
}: LegacyFormCustomFormItemDateProps) => {
	const {label, required} = item;

	return (
		<LegacyFormDateField
			fullWidth
			{...props}
			label={getCustomFormItemTranslatedLabel(label)}
			name={getCustomFormBaseFieldName(item)}
			required={required}
		/>
	);
};

export const LegacyFormCustomFormItemDate =
	LegacyFormCustomFormItemDatePrimitive;

export default LegacyFormCustomFormItemDate;
